<div class="d-flex flex-column" [formGroup]="contactFromGroup">
  <div class="w-100 mb-3">
    <div class="input-label">Contact</div>
    <input
      type="text"
      placeholder="Enter Contact"
      class="input"
      formControlName="name"
      maxlength="35"
    />
  </div>
  <div class="w-100 mb-3" *ngIf="contactFromGroup.get('title')">
    <div class="input-label">Title</div>
    <input
      type="text"
      placeholder="Enter Title"
      class="input"
      formControlName="title"
      maxlength="35"
    />
  </div>
  <div class="w-100 mb-3">
    <div class="input-label">Phone</div>
    <input
      type="text"
      placeholder="Enter Phone"
      mask="(000) 000-0000"
      class="input"
      formControlName="phone"
    />
  </div>
  <div class="w-100 mb-3">
    <div class="input-label">Fax</div>
    <input
      type="text"
      placeholder="Enter Fax"
      mask="(000) 000-0000"
      class="input"
      formControlName="fax"
    />
  </div>
  <div class="w-100">
    <div class="input-label">email</div>
    <input
      type="email"
      placeholder="Enter Email"
      class="input"
      formControlName="email"
      maxlength="320"
      [class.is-invalid]="
        contactFromGroup.get('email')?.touched &&
        contactFromGroup.get('email')?.invalid
      "
    />

    <div
      class="invalid-feedback text-left"
      *ngIf="
        contactFromGroup.get('email')?.invalid &&
        contactFromGroup.get('email')?.touched
      "
    >
      <div *ngIf="contactFromGroup.get('email')?.errors?.email">
        Must be email format like: 'example&#64;gmail.com'
      </div>
      <div *ngIf="contactFromGroup.get('email')?.errors?.pattern">
        Must be email format like: 'example&#64;gmail.com'
      </div>
    </div>
  </div>
</div>
